import api from 'service/api'

const dponetAPI = api.create('dponet')
const dponetAPInotTrait = api.create('dponet', false)

const create = async (data) => {
  return await dponetAPI.postForm('/tickets/juridic', { ticket: data })
}

const reopenTicket = async ({ ticketId }) => {
  return await dponetAPI.put(`/tickets/juridic/${ticketId}/reopen`)
}

const closeTicket = async ({ ticketId }) => {
  return await dponetAPI.put(`/tickets/juridic/${ticketId}/close`)
}

const preContractAnalysis = async ({ ...data }) => {
  return await dponetAPI.postForm(`/tickets/juridic/pre_contract_analysis`, {
    ...data,
  })
}

const preContractAnalysisFeedback = async ({ daiResponseId, ...data }) => {
  return await dponetAPInotTrait.post(
    `/tickets/juridic/pre_contract_analysis/${daiResponseId}/feedback`,
    data,
  )
}

const juridicTickets = {
  create,
  reopenTicket,
  closeTicket,
  preContractAnalysis,
  preContractAnalysisFeedback,
}

export default juridicTickets
